import { getParsedJSON } from '@/utilities/json.helper'
import { AWS_CONNECTION_SETTINGS_CREATE_REQUEST } from '@/store/modules/integrations/aws-connection-settings.type'
import { LOGSTASH_PORTS_REQUEST } from '@/store/modules/integrations/logstash.type'

export default {
  data () {
    return {
      integrationWizardIndex: 0,
      integrationLastStep: 3,
      integrationWizardSteps: [
        'Go to IAM console->Roles',
        'Create new role',
        'Select "Another AWS Account"',
        'Put Account# of Confluera <fixed account number>',
        'Select and attach two policies: AWSConfigRole policy and AWSConfigUserAccess policy',
        'Save role as ConfigAccessRole',
        'Note down the role ARN (e.g. arn:aws:iam::347227527012:role/ConfigAccessRole)'
      ],
      integrationWizardData: {
        scanFrequency: 60000
      },
      integrationWizardForm: null,
      apiDispatchState: AWS_CONNECTION_SETTINGS_CREATE_REQUEST,
      apiCall: {
        outbound: false,
        error: false,
        errMsg: ''
      }
    }
  },
  watch: {
    'integrationWizardData.nickName': {
      handler: function (newVal, oldVal) {
        this.integrationWizardData.nickName = newVal.replace(/\s+/g, '') // removes spaces on paste
      }
    }
  },
  methods: {
    gotoDiscoveryIntegrationWorkflow () {
      this.$router.push({
        name: 'discoveryintegration-accounts'
      })
    },
    gotoAlertIntegrationWorkflow () {
      this.$emit('close-page')
    },
    handleIntegrationSelect (integration) {
      this.integration = integration
    },
    nextIntegrationStep () {
      if (this.integrationWizardIndex < this.integrationWizardSteps.length) {
        this.integrationWizardIndex++
        this.$refs.wizard.setActiveItem(this.integrationWizardIndex)
      }
      if (this.integrationWizardIndex === this.integrationWizardSteps.length) {
        this.integrationWizardForm = this.integrationWizardData
      }
    },
    backIntegrationStep () {
      // if in error code, go back 2
      if (this.integrationWizardIndex === this.integrationLastStep) {
        this.apiCall.error = false
        this.integrationWizardIndex--
      }
      if (this.integrationWizardIndex > 0) {
        this.integrationWizardIndex--
      }
      this.$refs.wizard.setActiveItem(this.integrationWizardIndex)
    },
    updateIntegrationSettings () {
      this.apiCall.outbound = true
      this.$store.dispatch(this.apiDispatchState, this.integrationWizardData).then(
        resp => {
          this.nextIntegrationStep()
          this.apiCall.outbound = false
          this.apiCall.error = false
        },
        errMsg => {
          if (errMsg.data && errMsg.data.message) {
            errMsg = getParsedJSON(errMsg.data.message)
          }

          this.integrationWizardIndex++
          this.nextIntegrationStep()

          this.apiCall.error = true
          this.apiCall.errorMsg = errMsg
        }
      )
    },
    getLogstashPorts () {
      this.$store.dispatch(LOGSTASH_PORTS_REQUEST).then(
        resp => {},
        errMsg => {
          if (errMsg.data && errMsg.data.message) {
            errMsg = getParsedJSON(errMsg.data.message)
          }
        }
      )
    },
    cancelIntegrationSettings () {},
    validateNickName () {
      let isValidNickName = true
      let errMsg

      if (!this.integrationWizardData.nickName) {
        isValidNickName = false
        errMsg = 'Please enter a valid nickname'
      } else if (_.has(this.cloudIntegrationAccounts, 'models') && this.cloudIntegrationAccounts.models.length) {
        for (let acct of this.cloudIntegrationAccounts.models) {
          if (this.integrationWizardData.nickName.toLowerCase() === acct.nickName.toLowerCase()) {
            errMsg = 'Nickname already exists'
            isValidNickName = false
            break
          }
        }
      }

      if (isValidNickName) {
        this.nextIntegrationStep()
      } else {
        this.$message({
          type: 'error',
          message: errMsg
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/form/integrations/integrationFormMixin.js